<template>
  <layout>
    <span slot="header">{{ title }}
      <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
      <i class="fas fa-print" style="font-size: 22px !important; float: right; margin-right: 70px;" @click="goPrint"></i>
    </span>
    <div slot="content">
<!--      v-for="(item, i) in asReadDetail" :key="i"-->
      <ProcsHstScreen id="printf" class="subpage" :asReadDetail="asReadDetail"/>
    </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
import ProcsHstScreen from "@/components/AS/CallTreat/Modal/ProcsHst/ProcsHstScreen2";
/**
 * lodash
 */

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  components: {Layout, ProcsHstScreen},
  props: ['asId'],
    // data: {
    //   Type: Object,
    //   default: {
    //     asId: ''
    //   }
    // }
  // },
  data() {
    return {
      title: '접수내역서',
      rowData: [],
      asReadDetail : [],
      form : {
        companyId : '',
        asId: '',
        processTime : ''
      },
    }
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.form.asId = this.asId;
    this.getAsReadDetailInfo();
  },
  computed: {
    printStyle() {
      return `body {
          width: 100%;
          height: 100%;
          margin: 0;
          padding: 0;
          background-color: #FAFAFA;
          font: 10pt "Tahoma";
        }
        * {
          box-sizing: border-box;
          -moz-box-sizing: border-box;
        }
        .page {
          width: 210mm;
          min-height: 297mm;
          padding: 20mm;
          margin: 10mm auto;
          border: 1px #D3D3D3 solid;
          border-radius: 5px;
          background: white;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
        .subpage {
          padding: 1cm;
          border: 5px red solid;
          height: 257mm;
          outline: 2cm #FFEAEA solid;
        }
        @page {
          size: A4;
          margin: 0;
        }
        @media print {
          html, body {
            width: 210mm;
            height: 297mm;
          }
          .page {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            min-height: initial;
            box-shadow: initial;
            background: initial;
            page-break-after: always;
          }
        }`
    }
  },
  methods: {
    goPrint(){

      var printDiv = document.getElementById("printf");
      var pop = window.open(this.url, '_blank');

      pop.document.write(`<!DOCTYPE html><head><meta charset="utf-8"><title>LUCOMS 서비스</title></head><body>`);
      pop.document.write(printDiv.innerHTML);
      pop.document.write(`</body>
        <style>
        ${this.printStyle}
        </style>
      </html>`);

      pop.document.close();

      setTimeout(function() {
        pop.print();
        pop.close();
      }, 200);
    },
    getAsReadDetailInfo(){

      let that = this

      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        asId: this.form.asId
      }
      console.log(vForm)
      this.$http.post(_url("/api/asMng/call/asReadDetailPrint"), vForm).then(response => {
        this.asReadDetail = response.data
        console.log('???', response.data)
        this.changeData();
        /* data customize */
      }).finally(() => {
        this.$store.commit('finish')
      });

    },
    changeData(){
      this.asReadDetail.map((x, i) => {
        let callChange = ''

        let prodChange = ''
        let prod = [];

        let purchaseDtChange = ''
        let purchase = [];

        if(x.callDt === null || x.callDt === '' || x.callDt === undefined) x.callDt = '';
        else {
          callChange = this.$moment(x.callDt).format('YYYY-MM-DD HH:mm')
          x.callDt = callChange;
        }

        if (x.prodDt === null || x.prodDt === '' || x.prodDt === undefined) x.prodDt = '';
        else {
          prod = this.$moment(x.prodDt).format('YYYY-MM').split('-');
          prodChange = prod[0] + " 년 " + prod[1] + " 월";
          x.prodDt = prodChange;
        }

        console.log(this.$moment(x.purchaseDt).format('YYYY-MM'))

        if (x.purchaseDt === null || x.purchaseDt === '' || x.purchaseDt === undefined) x.purchaseDt = '';
        else {
          purchase = this.$moment(x.purchaseDt).format('YYYY-MM').split('-');
          purchaseDtChange = purchase[0] + " 년 " + purchase[1] + " 월";
          x.purchaseDt = purchaseDtChange;
        }

        x.hpNo = _phone(x.hpNo);
        
        return x;
      })
    }
  },

}
</script>

<style scoped>

</style>